// globalFunc.js
import { EventBus } from './eventBus'

export default {
  install (Vue) {
    Vue.prototype.handleSelfSelect = function () {
      this.GLOBAL.dialogOpen = true
    }
    Vue.prototype.handleSelectTab = function (index, tabName) {
      this.GLOBAL.tabs[this.GLOBAL.selectedTabIndex].selected = false
      this.GLOBAL.tabs[index].selected = true
      this.GLOBAL.selectedTabIndex = index

      switch (tabName) {
        case '行情':
          if (this.$route.path !== '/') {
            this.$router.push('/')
          }
          break
        case '快讯':
          if (this.$route.path !== '/Consult') {
            this.$router.push('/Consult')
          }
          break
        case '简介':
          if (this.$route.path !== '/AboutUs') {
            this.$router.push('/AboutUs')
          }
          break
      }
    }
    Vue.prototype.onClickOptionalItem = function (type, item, index) {
      switch (type) {
        case 'all':
          let isSelectAll = this.GLOBAL.selectMap.every(item => item.state)
          if (isSelectAll) {
            this.GLOBAL.selectMap.forEach(item => { item.state = false })
          } else {
            this.GLOBAL.selectMap.forEach(item => { item.state = true })
          }
          break
        case 'item':
          this.GLOBAL.selectMap[index].state = !this.GLOBAL.selectMap[index].state
          break
      }
    }
    Vue.prototype.handleSave = function () {
      localStorage.selectMap = JSON.stringify(this.GLOBAL.selectMap)
      this.GLOBAL.dialogOpen = false
    }

    Vue.prototype.startHttpPolling = function () {
      if (this.GLOBAL.pollingInterval) {
        clearInterval(this.GLOBAL.pollingInterval)
      }

      this.fetchPriceData()

      this.GLOBAL.pollingInterval = setInterval(() => {
        this.fetchPriceData()
      }, 1000)
    }

    Vue.prototype.fetchPriceData = function () {
      const url = this.GLOBAL.HTTP_API_URL + (this.GLOBAL.HTTP_API_URL.includes('?') ? '&' : '?') + 't=' + Date.now()
      fetch(url)
        .then(response => {
          if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`)
          }
          return response.json()
        })
        .then(data => {
          // 处理返回的数据格式
          const processedData = this.processPriceData(data)

          this.$set(this.GLOBAL, 'date', processedData.date)
          this.$set(this.GLOBAL, 'status', processedData.status)
          this.$set(this.GLOBAL, 'tableList', processedData.priceData)

          EventBus.$emit('dateUpdated', this.GLOBAL.date)
          EventBus.$emit('statusUpdated', this.GLOBAL.status)
          EventBus.$emit('tabListUpdated', this.GLOBAL.tableList)
        })
        .catch(error => {
          console.error('获取价格数据失败:', error)
          // 设置默认状态
          this.$set(this.GLOBAL, 'date', '连接失败')
          this.$set(this.GLOBAL, 'status', '--')
          this.$set(this.GLOBAL, 'tableList', {})
        })
    }

    Vue.prototype.processPriceData = function (data) {
      if (Array.isArray(data) && data.length > 0) {
        const item = data[0]
        const items = item.items || {}
        const pubtime = item.pubtime || new Date().toLocaleString()
        const result = item.result || '开盘'

        const priceData = {}
        Object.keys(items).forEach(key => {
          const itemData = items[key]
          priceData[key] = {
            Buy: itemData.Buy || '0.00',
            Sell: itemData.Sell || '0.00',
            H: itemData.H || '0.00',
            L: itemData.L || '0.00',
            C: itemData.C || key,
            name: itemData.name || key
          }
        })

        return {
          date: pubtime,
          status: result,
          priceData: priceData
        }
      }

      return {
        date: new Date().toLocaleString(),
        status: '停盘',
        priceData: {}
      }
    }

    /*
    Vue.prototype.connectWebSocket = function () {
      this.GLOBAL.socket = new WebSocket(this.GLOBAL.SOCKET_URL)

      this.GLOBAL.socket.addEventListener('open', (event) => {
        console.log('WebSocket connection is open', event)
      })

      this.GLOBAL.socket.addEventListener('message', (event) => {
        const receivedData = JSON.parse(event.data)
        this.$set(this.GLOBAL, 'date', receivedData.date)
        this.$set(this.GLOBAL, 'status', receivedData.status)
        this.$set(this.GLOBAL, 'tableList', receivedData.priceData)
        EventBus.$emit('dateUpdated', this.GLOBAL.date)
        EventBus.$emit('statusUpdated', this.GLOBAL.status)
        EventBus.$emit('tabListUpdated', this.GLOBAL.tableList)
      })

      this.GLOBAL.socket.addEventListener('close', (event) => {
        console.log('WebSocket connection is closed', event)
        this.startReconnectInterval()
      })

      this.GLOBAL.socket.addEventListener('error', (event) => {
        console.error('WebSocket error:', event)
      })
    }
    */

    Vue.prototype.connectWebSocket = function () {
      this.startHttpPolling()
    }

    /*
    Vue.prototype.reconnectWebSocket = function () {
      if (!this.GLOBAL.socket || this.GLOBAL.socket.readyState !== WebSocket.OPEN) {
        console.log('Reconnecting WebSocket...')
        this.connectWebSocket()
      }
    }
    Vue.prototype.startReconnectInterval = function () {
      clearInterval(this.GLOBAL.reconnectInterval)
      this.GLOBAL.reconnectInterval = setInterval(() => {
        this.reconnectWebSocket()
      }, 5000)
    }
    Vue.prototype.closeWebSocket = function () {
      if (this.GLOBAL.socket && this.GLOBAL.socket.readyState === WebSocket.OPEN) {
        this.GLOBAL.socket.close()
      }
      clearInterval(this.GLOBAL.reconnectInterval)
    }
    */

    Vue.prototype.reconnectWebSocket = function () {
      this.startHttpPolling()
    }
    Vue.prototype.startReconnectInterval = function () {
      this.startHttpPolling()
    }
    Vue.prototype.closeWebSocket = function () {
      if (this.GLOBAL.pollingInterval) {
        clearInterval(this.GLOBAL.pollingInterval)
        this.GLOBAL.pollingInterval = null
      }
    }

    Vue.prototype.handleSelfSelectOther = function () {
      this.GLOBAL.dialogOpenOther = true
    }
    Vue.prototype.onClickOptionalItemOther = function (type, item, index) {
      switch (type) {
        case 'all':
          let isSelectAll = this.GLOBAL.selectMapOther.every(item => item.state)
          if (isSelectAll) {
            this.GLOBAL.selectMapOther.forEach(item => { item.state = false })
          } else {
            this.GLOBAL.selectMapOther.forEach(item => { item.state = true })
          }
          break
        case 'item':
          this.GLOBAL.selectMapOther[index].state = !this.GLOBAL.selectMapOther[index].state
          break
      }
    }
    Vue.prototype.handleSaveOther = function () {
      localStorage.selectMapOther = JSON.stringify(this.GLOBAL.selectMapOther)
      this.GLOBAL.dialogOpenOther = false
    }
  }
}



// WEBPACK FOOTER //
// ./src/common/globalFunc.js